import { Button } from 'design-system';
import { JSX, useMemo } from 'react';

const DEFAULT_FIELD_WIDTH = '160px';
const DEFAULT_FIELD_HEIGHT = '40px';

export interface ImageUploadFieldProps {
  label?: string;
  justifyContent?: string;
  hasWhiteFields?: boolean;
  isUploadDisabled?: boolean;
  hasUploadFile?: boolean;
  onClick: () => void;
  renderFieldContent: (justifyContent?: string) => JSX.Element;
}

const ImageUploadButtonField: React.FC<ImageUploadFieldProps> = ({
  label = '',
  justifyContent = 'space-between',
  hasWhiteFields = false,
  isUploadDisabled = false,
  hasUploadFile = false,
  onClick,
  renderFieldContent,
}) => {
  const buttonStyles = useMemo(
    () => ({
      width: DEFAULT_FIELD_WIDTH,
      height: DEFAULT_FIELD_HEIGHT,
      padding: hasUploadFile ? 0 : 1,
      background: hasWhiteFields ? 'background.paper' : 'initial',
      opacity: isUploadDisabled ? 0.6 : 1,
    }),
    [hasUploadFile, hasWhiteFields, isUploadDisabled],
  );

  return (
    <Button
      color="primary"
      variant="outlined"
      disabled={isUploadDisabled}
      sx={buttonStyles}
      onClick={onClick}
      aria-label={hasUploadFile ? `View uploaded ${label || 'files'}` : `Upload ${label || 'file'}`}
    >
      {renderFieldContent(justifyContent)}
    </Button>
  );
};

export default ImageUploadButtonField;
